import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { apiWrapper } from "../../../../api/apiWrapper";
import { ISelectDgtxKetQuaRequest } from "../../../../models/request/danh-gia/thuong-xuyen/ISelectDgtxKetQuaRequest";
import { IHocSinhSelectRequest } from "../../../../models/request/hoc-sinh/IHocSinhSelectRequest";
import { IBaseResponeModel } from "../../../../models/response/base-response";
import { IDgtxKetQua } from "../../../../models/response/danh-gia/thuong-xuyen/IDgtxKetQua";
import { eDgTuanKetQuaActionTypeIds, IDgTuanKetQuaActionTypes } from "../../../action-types/danh-gia/tuan/IDgTuanKetQuaActionType";
import { actions } from '../../../actions/actionsWrapper';

const hocSinhApi = apiWrapper.hocSinh;
const dgdkDmPhamChatApi = apiWrapper.soNhanXetItem;
const dgtxKetQuaApi = apiWrapper.danhGia.thuongXuyen.nlpc;

export function* dgTuanKetQuaSaga(): any {
    yield takeLatest(eDgTuanKetQuaActionTypeIds.HOC_SINH_LOAD_START, loadHocSinhWorker)
    yield takeLatest(eDgTuanKetQuaActionTypeIds.SO_NHAN_XET_ITEM_LOAD_START, loadDmNLPCWorker)
    yield takeLatest(eDgTuanKetQuaActionTypeIds.KET_QUA_LOAD_START, loadKetQuaWorker)
    yield takeEvery(eDgTuanKetQuaActionTypeIds.SAVE_KETQUA_START, saveKetQuaWorker)

}

function* loadHocSinhWorker(action: IDgTuanKetQuaActionTypes): any {
    const res: IBaseResponeModel = yield call(hocSinhApi.Select, action.payload as IHocSinhSelectRequest)
    if (res.is_success) {
        yield put(actions.danhGia.tuan.HOC_SINH_LOAD_SUCCESS(res.data))
    } else {
        yield put(actions.danhGia.tuan.HOC_SINH_LOAD_ERROR(res.message ?? ""))
    }
}

function* loadDmNLPCWorker(action: IDgTuanKetQuaActionTypes): any {
    const res: IBaseResponeModel = yield call([dgdkDmPhamChatApi, dgdkDmPhamChatApi.SelectBySet], action.payload as number)
    if (res.is_success) {
        yield put(actions.danhGia.tuan.SO_NHAN_XET_ITEM_LOAD_SUCCESS(res.data))
    } else {
        yield put(actions.danhGia.tuan.SO_NHAN_XET_ITEM_LOAD_ERROR(res.message ?? ""))
    }
}

function* loadKetQuaWorker(action: IDgTuanKetQuaActionTypes): any {
    const res: IBaseResponeModel = yield call(dgtxKetQuaApi.Select, action.payload as ISelectDgtxKetQuaRequest)
    if (res.is_success) {
        yield put(actions.danhGia.tuan.KET_QUA_LOAD_SUCCESS(res.data))
    } else {
        yield put(actions.danhGia.tuan.KET_QUA_LOAD_ERROR(res.message ?? ""))
    }
}


function* saveKetQuaWorker(action: IDgTuanKetQuaActionTypes): any {
    const res: IBaseResponeModel = yield call(dgtxKetQuaApi.SaveKetQuaTuan, action.payload as IDgtxKetQua)
    if (res.is_success) {
        yield put(actions.danhGia.tuan.SAVE_KETQUA_SUCCESS(res.data))
    } else {
        yield put(actions.danhGia.tuan.SAVE_KETQUA_ERROR(res.message ?? ""))
    }
}
